import { SpeedDial, SpeedDialIcon } from '@mui/material';
import { Box } from '@mui/system';
import React, { useCallback, useEffect, useState } from 'react';
import SystemsTable from '../../../../components/administrative/systems/systemsTable/systemsTable';
import SystemDialog from '../../../../components/administrative/systems/systemDialog/systemDialog';
import axiosInstance from '../../../../config/axio.config';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';

const url = '/systems';

const SystemsPage = () => {
  const { ShowMessage } = useShowMessages();
  const [values, setValues] = useState({});
  const [open, setOpen] = useState(false);
  const [changed, setChanged] = useState(false);
  const [systems, setSystems] = useState([]);

  const handleChanged = () => {
    setChanged((prev) => !prev);
  }

  const loadSystems = useCallback(async () => {
    try {
      const response = await axiosInstance.get(url);
      // A API responde 204 sem corpo quando não há nenhum sistema.
      setSystems(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      ShowMessage('error', 'Erro ao carregar os sistemas');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { loadSystems(); }, [loadSystems, changed]);

  const handleNewSystem = () => {
    setValues({ active: 'Y' });
    setOpen(true);
  }

  const handleEdit = (system) => {
    setValues({ ...system });
    setOpen(true);
  }

  // Os tipos já cadastrados viram sugestão no diálogo, evitando "Automação"/"automacao".
  const types = [...new Set(systems.map((system) => system.type).filter(Boolean))].sort();

  return (
    <div style={{padding: 20}}>
      <Box>
        <SystemDialog
          open={open}
          setOpen={setOpen}
          values={values}
          setValues={setValues}
          types={types}
          handleChanged={handleChanged}
        />
      </Box>
      <div>
        <SpeedDial
          ariaLabel="Novo sistema"
          sx={{ position: 'fixed', bottom: 120, right: 16 }}
          icon={<SpeedDialIcon />}
          onClick={() => handleNewSystem()}
        >
        </SpeedDial>
      </div>
      <SystemsTable
        systems={systems}
        handleEdit={handleEdit}
        handleChanged={handleChanged}
      />
    </div>
  )
}

export default SystemsPage;
